// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/myAccount/drop-arrow-gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment_bg-gray-100__Faes8 {
    background-color: #f5f5f5 !important;
}
.payment_tru-mma-main-wrapper__8PxIA {
    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75) !important;
    border: 1px solid #ced4da !important;
}
.payment_p-10__fjyFR {
    padding: 10px;
}
.payment_p-20__iiBKM {
    padding: 20px !important;
}
.payment_gfs-24__Y1NgK {
    font-size: 24px !important;
}
.payment_gfw-3__lPTFQ {
    font-weight: 300 !important;
}
.payment_gfw-4__f\\+hSR {
    font-weight: 400 !important;
}
.payment_g-font-weight-700__5H1Gn{
    font-weight: 700;
}
.payment_lh-1-2__bhBl0{
    line-height: 1.2;
}
.payment_bg-white__xYr0s {
    color: #666;
}
.payment_gfs-14__YqtJi {
    font-size: 14px;
    font-family: Source Sans Pro,
        -apple-system,
        BlinkMacSystemFont,
        Segoe UI,
        Roboto,
        Helvetica Neue,
        Arial,
        sans-serif,
        Apple Color Emoji,
        Segoe UI Emoji,
        Segoe UI Symbol;
}
.payment_sucesspayment-table-pd-top__9tMwS {
    padding-top: 18px !important;
    padding-left: 15px;
    padding-right: 15px;
    
}
.payment_sucesspayment-table-bg-color__oMmRw {
    background-color: #f5f5f5 !important;
    --bs-table-bg: #f5f5f5 !important;
}

.payment_sucesspayment-table-bg-color__oMmRw tbody tr td{
    padding-left: 0 !important;
    padding-right: 0 !important;
    font-weight: 400;
}
.payment_payment-section__Q4ib0 {
    background-color: #f5f5f5;
    /* Light gray */
    padding: 20px;
    border-radius: 0px;
}
.payment_recent-payment-option__0D1vN {
    appearance: none !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-position: 100% !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
    height: 40px !important;
    min-height: 0 !important;
    max-width: 100% !important;
    padding: 0 50px 0 5px !important;
    font-size: 14px !important;
    border: 1px solid #e6e9ee !important;
    color: #222222 !important;
    font-weight: 300 !important;
    border-radius: 0 !important;
}
#payment_errorMessage__K4ZCS .payment_bg-dark__TUXBK {
    background-color: #414141 !important;
}
#payment_errorMessage__K4ZCS .payment_p-12__op3bJ {
    padding: 12px !important;
}
#payment_errorMessage__K4ZCS .payment_mb-20__vq3LL {
    margin-bottom: 20px !important;
}
#payment_errorMessage__K4ZCS .payment_tg-ft-26pt__SOkoI {
    font-size: 26pt;
} 
#payment_errorMessage__K4ZCS .payment_tg-ft-20pt__v1IcA {
    font-size: 20pt;
} 
#payment_errorMessage__K4ZCS .payment_tg-ft-15pt__91RSz {
    font-size: 15pt;
} 
#payment_errorMessage__K4ZCS .payment_btn-primary__tAETz {
    background-color: #ffb034 !important;
    border: none !important;
}
@media only screen and (max-width: 767px) {
    .payment_tru-mma-main-wrapper__8PxIA {
        box-shadow: none !important;
        border: 0 !important;
        background: none !important;
        padding: 0 10px !important;
        margin-bottom: 40px;
        line-height: 1.2;
    }
    .payment_py-30__SHTAA {
        padding-top: 30px;
    } 
    .payment_tru-mma-main-collapse-box__sOT\\+5{
        border: 1px solid #ced4da;
        font-weight: 300;
    }
    .payment_mob-mlr-0__hfnG0{
        padding-left: 0;
        padding-right: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/myAccount/payment.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;AACA;IACI,0DAA0D;IAC1D,oCAAoC;AACxC;AACA;IACI,aAAa;AACjB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf;;;;;;;;;;uBAUmB;AACvB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;;AAEvB;AACA;IACI,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;AACA;IAGI,2BAA2B;IAC3B,oEAAsF;IACtF,oCAAoC;IACpC,uCAAuC;IACvC,mCAAmC;IACnC,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,gCAAgC;IAChC,0BAA0B;IAC1B,oCAAoC;IACpC,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,oCAAoC;AACxC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;AACA;IACI;QACI,2BAA2B;QAC3B,oBAAoB;QACpB,2BAA2B;QAC3B,0BAA0B;QAC1B,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,yBAAyB;QACzB,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".bg-gray-100 {\n    background-color: #f5f5f5 !important;\n}\n.tru-mma-main-wrapper {\n    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75) !important;\n    border: 1px solid #ced4da !important;\n}\n.p-10 {\n    padding: 10px;\n}\n.p-20 {\n    padding: 20px !important;\n}\n.gfs-24 {\n    font-size: 24px !important;\n}\n.gfw-3 {\n    font-weight: 300 !important;\n}\n.gfw-4 {\n    font-weight: 400 !important;\n}\n.g-font-weight-700{\n    font-weight: 700;\n}\n.lh-1-2{\n    line-height: 1.2;\n}\n.bg-white {\n    color: #666;\n}\n.gfs-14 {\n    font-size: 14px;\n    font-family: Source Sans Pro,\n        -apple-system,\n        BlinkMacSystemFont,\n        Segoe UI,\n        Roboto,\n        Helvetica Neue,\n        Arial,\n        sans-serif,\n        Apple Color Emoji,\n        Segoe UI Emoji,\n        Segoe UI Symbol;\n}\n.sucesspayment-table-pd-top {\n    padding-top: 18px !important;\n    padding-left: 15px;\n    padding-right: 15px;\n    \n}\n.sucesspayment-table-bg-color {\n    background-color: #f5f5f5 !important;\n    --bs-table-bg: #f5f5f5 !important;\n}\n\n.sucesspayment-table-bg-color tbody tr td{\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    font-weight: 400;\n}\n.payment-section {\n    background-color: #f5f5f5;\n    /* Light gray */\n    padding: 20px;\n    border-radius: 0px;\n}\n.recent-payment-option {\n    -webkit-appearance: none !important;\n    -moz-appearance: none !important;\n    appearance: none !important;\n    background-image: url(../../../public/images/myAccount/drop-arrow-gray.png) !important;\n    background-position: 100% !important;\n    background-repeat: no-repeat !important;\n    background-size: contain !important;\n    height: 40px !important;\n    min-height: 0 !important;\n    max-width: 100% !important;\n    padding: 0 50px 0 5px !important;\n    font-size: 14px !important;\n    border: 1px solid #e6e9ee !important;\n    color: #222222 !important;\n    font-weight: 300 !important;\n    border-radius: 0 !important;\n}\n#errorMessage .bg-dark {\n    background-color: #414141 !important;\n}\n#errorMessage .p-12 {\n    padding: 12px !important;\n}\n#errorMessage .mb-20 {\n    margin-bottom: 20px !important;\n}\n#errorMessage .tg-ft-26pt {\n    font-size: 26pt;\n} \n#errorMessage .tg-ft-20pt {\n    font-size: 20pt;\n} \n#errorMessage .tg-ft-15pt {\n    font-size: 15pt;\n} \n#errorMessage .btn-primary {\n    background-color: #ffb034 !important;\n    border: none !important;\n}\n@media only screen and (max-width: 767px) {\n    .tru-mma-main-wrapper {\n        box-shadow: none !important;\n        border: 0 !important;\n        background: none !important;\n        padding: 0 10px !important;\n        margin-bottom: 40px;\n        line-height: 1.2;\n    }\n    .py-30 {\n        padding-top: 30px;\n    } \n    .tru-mma-main-collapse-box{\n        border: 1px solid #ced4da;\n        font-weight: 300;\n    }\n    .mob-mlr-0{\n        padding-left: 0;\n        padding-right: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg-gray-100": `payment_bg-gray-100__Faes8`,
	"tru-mma-main-wrapper": `payment_tru-mma-main-wrapper__8PxIA`,
	"p-10": `payment_p-10__fjyFR`,
	"p-20": `payment_p-20__iiBKM`,
	"gfs-24": `payment_gfs-24__Y1NgK`,
	"gfw-3": `payment_gfw-3__lPTFQ`,
	"gfw-4": `payment_gfw-4__f+hSR`,
	"g-font-weight-700": `payment_g-font-weight-700__5H1Gn`,
	"lh-1-2": `payment_lh-1-2__bhBl0`,
	"bg-white": `payment_bg-white__xYr0s`,
	"gfs-14": `payment_gfs-14__YqtJi`,
	"sucesspayment-table-pd-top": `payment_sucesspayment-table-pd-top__9tMwS`,
	"sucesspayment-table-bg-color": `payment_sucesspayment-table-bg-color__oMmRw`,
	"payment-section": `payment_payment-section__Q4ib0`,
	"recent-payment-option": `payment_recent-payment-option__0D1vN`,
	"errorMessage": `payment_errorMessage__K4ZCS`,
	"bg-dark": `payment_bg-dark__TUXBK`,
	"p-12": `payment_p-12__op3bJ`,
	"mb-20": `payment_mb-20__vq3LL`,
	"tg-ft-26pt": `payment_tg-ft-26pt__SOkoI`,
	"tg-ft-20pt": `payment_tg-ft-20pt__v1IcA`,
	"tg-ft-15pt": `payment_tg-ft-15pt__91RSz`,
	"btn-primary": `payment_btn-primary__tAETz`,
	"py-30": `payment_py-30__SHTAA`,
	"tru-mma-main-collapse-box": `payment_tru-mma-main-collapse-box__sOT+5`,
	"mob-mlr-0": `payment_mob-mlr-0__hfnG0`
};
export default ___CSS_LOADER_EXPORT___;
